import _ from 'lodash';
import { useEffect, useState } from 'react';
import {
  convertMetricsNameToV3,
  getDashboardMetricsV3
} from 'common/services/metrics.service';
import { getAggregatedMetrics } from '../../groupDashboard.service';
import mockData from '../mock/groupDashboard.mock';
import { useDebounceCallback } from '@react-hook/debounce';

const useGroupMetricsTrend = ({
  dates,
  metricsCalculationStrategy,
  selectedGroup,
  current5Iterations,
  isIterations = true
}) => {
  const [metricsTrend, setMetricsTrend] = useState([]);

  const time_ranges = current5Iterations.map(
    ({ start_date: after, end_date: before }) => ({ before, after })
  );
  const selectedGroupId = _.get(selectedGroup, '[0].id');
  const isMockEnv = false;

  const handleFetchErrors = e => {
    return _.get(e, 'response.data.description', '');
  };

  const fetchGroupsMetricsTrend = async () => {
    try {
      const res = isMockEnv
        ? mockData.groupMetricsTrend
        : await getDashboardMetricsV3({
            time_ranges,
            requested_metrics: convertMetricsNameToV3(
              getAggregatedMetrics(),
              metricsCalculationStrategy
            ),
            teamId: selectedGroupId
          });

      setMetricsTrend(res);
    } catch (e) {
      handleFetchErrors(e);
    }
  };

  const debouncedFilterEntities = useDebounceCallback(
    fetchGroupsMetricsTrend,
    800
  );

  useEffect(() => {
    if (isIterations) {
      debouncedFilterEntities();
    }
  }, [dates.from, dates.to, selectedGroupId]);

  return {
    metricsTrend
  };
};

export default useGroupMetricsTrend;
